"use client"

import { KeySquare } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `KeySquareIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const KeySquareIcon = component(Icon)({ as: KeySquare })
